module.exports = __webpack_public_path__ + "videos/brushes-overlay.0cfa56e.mp4";